/**
 * Where "apply / become a Spatialist" links send people: the public
 * Spatialists page on the marketing site, which hosts the application
 * (founder, 2026-09-30). Outreach emails keep their own `/join/{campaign}`
 * links because those carry the invite token and campaign source.
 */
export const SPATIALIST_APPLY_URL = "https://www.virtualspace.xyz/spatialists";
